import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from "../../images/slider/slide-2.jpg";
import hero2 from "../../images/slider/slide-3.jpg";

class Hero3 extends Component {
  render() {
    var settings = {
      dots: false,
      arrows: true,
      speed: 1200,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 10000,
      fade: true,
    };

    return (
      <section className="wpo-hero-slider">
        <div className="hero-container">
          <div className="hero-wrapper">
            <Slider {...settings}>
              <div className="hero-slide">
                <div
                  className="slide-inner slide-bg-image"
                  style={{
                    backgroundImage: `url(${hero1})`,
                    backgroundPositionX: "right",
                  }}
                >
                  <div className="container mb-hero">
                    <div className="slide-content">
                      <div className="slide-title">
                        <h2>Há mais de 20 anos conectando pessoas</h2>
                      </div>
                      <div className="slide-text">
                        <p>
                          Unimos experiência e empatia para oferecer soluções em
                          RH com agilidade, coerência e foco humanizado.
                        </p>
                      </div>
                      <div className="clearfix"></div>
                      <div className="slide-btns">
                        <a
                          href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                          target="_blank"
                          rel="noreferrer"
                          className="btn theme-btn"
                        >
                          Fale conosco
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="hero-slide">
                <div
                  className="slide-inner slide-bg-image"
                  style={{
                    backgroundImage: `url(${hero2})`,
                    backgroundPositionX: "right",
                  }}
                >
                  <div className="container mb-hero">
                    <div className="slide-content">
                      <div className="slide-title">
                        <h2>TRANSIÇÃO DE CARREIRA</h2>
                      </div>
                      <div className="slide-text">
                        <p>
                          Para profissionais em busca de propósito e empresas
                          que valorizam pessoas.
                        </p>
                      </div>
                      <div className="clearfix"></div>
                      <div className="slide-btns">
                        <a
                          href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                          target="_blank"
                          rel="noreferrer"
                          className="btn theme-btn"
                        >
                          Fale conosco
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default Hero3;

<style>{`@media (max-width: 768px) {
  .slide-bg-image {
    background-image: none !important;
    background-color: #07162c !important;
  }
}
`}</style>;
